<template>
    <!-- HEADER PAGINE VETRINA -->
    <header
        v-if="showHeader('SHOPPAGES')"
        role="navigation"
        class="navbar fixed-top px-0"
    >
        <div class="container">
            <div class="navbar navbar-expand-md navbar-dark w-100 p-0">
                <button
                    class="navbar-toggler order-1 p-0 border-0"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <span class="navbar-brand order-2 mr-0 mr-md-3">
                    <router-link :to="{ name: 'home' }">
                        <img
                            src="images/logo.png"
                            alt="RikordaEventi"
                        />
                    </router-link>

                </span>

                <div class="menu-dx d-inline-flex justify-content-end align-items-center order-3 order-md-4">
                    <router-link
                        :to="{name: 'backend'}"
                        class="nav-link p-0 text-uppercase d-inline-flex align-items-center"
                    >
                        <font-awesome-icon
                            :icon="['fa', 'user']"
                            class="pt-1 mr-2"
                        />
                        <span>Accedi ora</span>
                    </router-link>
                </div>

                <nav
                    id="navbarSupportedContent"
                    class="collapse navbar-collapse order-4 order-md-3"
                >
                    <div class="navbar-nav align-items-center text-uppercase">
                        <router-link
                            :to="{ name: 'features' }"
                            class="nav-item nav-link mx-1 mr-lg-3 ml-md-0 py-md-0"
                            :class="{ active: $route.name === 'features' }"
                        >Caratteristiche</router-link>
                        <router-link
                            :to="{ name: 'advantages' }"
                            class="nav-item nav-link mx-1 mx-lg-3 py-md-0"
                            :class="{ active: $route.name === 'advantages' }"
                        >Vantaggi</router-link>
                        <!--a
                                    class="nav-item nav-link mx-1 mx-lg-3 py-md-0"
                                    href="#"
                                >F.A.Q.</a-->
                        <!--router-link
                            :to="{ name: 'page-howitworks' }"
                            class="nav-item nav-link mx-1 ml-lg-3 mr-md-0 py-md-0"
                            :class="{ active: $route.name === 'page-howitworks' }"
                        >
                            <font-awesome-icon :icon="['fas', 'question-circle']" />
                            &nbsp;{{ $t("Come funziona") }}
                        </router-link-->
                        <router-link
                            :to="{ name: 'page-request-contact' }"
                            class="nav-item nav-link mx-1 ml-lg-3 mr-md-0 py-md-0"
                            :class="{ active: $route.name === 'page-contacts' }"
                        >
                            <!--font-awesome-icon :icon="['fas', 'comments']" /-->
                            &nbsp;{{ $t("Contatti") }}
                        </router-link>
                    </div>
                </nav>
            </div>
        </div>
    </header>

    <!-- HEADER PAGINE LOGIN (SIA FRONTEND CHE BACKEND) -->
    <header
        v-else-if="showHeader('LOGIN')"
        role="navigation"
        class="navbar fixed-top px-0"
    >
        <div class="container">
            <div class="navbar navbar-expand-md navbar-dark w-100 p-0">
                <button
                    class="navbar-toggler order-1 p-0 border-0"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <span class="navbar-brand order-2 mr-0 mr-md-3">
                    <router-link :to="{ name: isGlobalSite ? 'home' : '' }">
                        <img
                            v-if="logoUrl"
                            :src="logoUrl"
                            alt="RikordaEventi"
                            class="mw-100 mh-100"
                        />
                    </router-link>
                </span>

                <nav
                    id="navbarSupportedContent"
                    class="collapse navbar-collapse justify-content-end order-4 order-md-3 mr-lg-3"
                >
                    <div class="navbar-nav align-items-center text-uppercase">
                        <router-link
                            v-if="isGlobalSite"
                            :to="{ name: 'page-howtostart' }"
                            class="nav-item nav-link mx-1 mr-lg-3 ml-md-0 py-md-0 d-inline-flex align-items-center"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'play-circle']"
                                class="mr-2"
                            />
                            &nbsp;{{ $t("Come iniziare") }}
                        </router-link>
                        <router-link
                            :to="{ name: 'page-howitworks' }"
                            class="nav-item nav-link mx-1 mr-lg-3 ml-md-0 py-md-0 d-inline-flex align-items-center"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'question-circle']"
                                class="mr-2"
                            />
                            &nbsp;{{ $t("Come funziona") }}
                        </router-link>
                        <router-link
                            :to="{ name: (!isGlobalSite) ? 'page-contacts' : 'page-request-contact' }"
                            class="nav-item nav-link mx-1 mr-lg-3 ml-md-0 py-md-0 d-inline-flex align-items-center"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'comments']"
                                class="mr-2"
                            />
                            &nbsp;{{ $t("Contatti") }}
                        </router-link>
                    </div>
                </nav>
            </div>
        </div>
    </header>

    <header
        v-else-if="showHeader('PHOTOSELECTION')"
        role="navigation"
        class="navbar navbar-expand-md fixed-top navbar-light shadow"
    >
        <b-navbar
            toggleable="md"
            id="navbarSupportedContent"
            class="navbar-collapse p-0"
        >
            <div
                id="nav-collapse"
                is-nav
                class="pulsante-indietro navbar-nav align-items-center text-uppercase"
            >
                <a
                    @click.prevent="onPhotoselectionBackClicked()"
                    class="nav-item nav-link"
                    href="#"
                >
                    <font-awesome-icon :icon="['fas', 'arrow-left']" />
                    &nbsp;<span class="d-none d-sm-inline">
                        {{
                        $t("Indietro")
                    }}</span>
                </a>
            </div>

            <!-- FIXME -->
            <span class="navbar-text px-2 text-center text-truncate flex-grow-1 titolo-album">
                {{ $t('SELEZIONA X FOTO') }}
            </span>
        </b-navbar>
    </header>

    <!-- HEADER UTENTE LOGGATO -->
    <header
        v-else
        role="navigation"
        class="navbar navbar-expand-md fixed-top navbar-light shadow"
    >
        <b-navbar-toggle
            target="nav-collapse"
            class="navbar-toggler border-0 p-0"
            v-if="showHeader('')"
        />

        <span
            class="navbar-brand mr-0 mr-md-1 mr-lg-3 p-0 d-inline-flex align-items-center"
            v-if="showHeader('')"
        >
            <img
                v-if="logoUrl"
                :src="logoUrl"
                alt="RikordaEventi"
                class="mw-100 mh-100"
            />
        </span>

        <div
            class="d-block d-md-none icona-menu-mobile-carrello"
            v-if="showHeader('')"
        >
            <router-link
                :to="{ name: 'gallery-cart' }"
                class="position-relative d-block d-md-none"
                active-class="active"
                exact
                :class="{ 'carrello-vuoto': numCartItems < 1 }"
                v-if="!isAuthor"
            >
                <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                <span class="contatore-prodotti-carrello position-absolute font-weight-bold d-inline-flex justify-content-center align-items-center">
                    {{ numCartItems }}
                </span>
            </router-link>
        </div>

        <b-navbar
            toggleable="md"
            id="navbarSupportedContent"
            class="navbar-collapse p-0"
            v-if="showHeader('')"
        >
            <b-collapse
                id="nav-collapse"
                is-nav
                class="navbar-nav pt-3 pt-md-0 align-items-center text-uppercase p-0  text-md-center"
            >
                <!-- TODO: centrare -->
                <router-link
                    :to="{
                        name: 'gallery-dashboard',
                        params: { galleryUrl: $route.params.galleryUrl }
                    }"
                    class="nav-item nav-link mr-md-2 mr-lg-3 p-md-1 p-lg-2"
                    active-class="active"
                    exact
                >
                    <font-awesome-icon :icon="['fas', 'home']" />
                    &nbsp;{{ $t("Home") }}
                </router-link>

                <router-link
                    :to="{ name: 'gallery-info' }"
                    class="nav-item nav-link mx-md-2 mx-lg-3 p-md-1 p-lg-2"
                    active-class="active"
                    exact
                >
                    <font-awesome-icon :icon="['fas', 'info-circle']" />
                    &nbsp;{{ $t("Info") }}
                </router-link>

                <router-link
                    :to="{ name: 'gallery-favorites' }"
                    class="nav-item nav-link mx-md-2 mx-lg-3 p-md-1 p-lg-2 position-relative"
                    active-class="active"
                    exact
                    v-if="!isAuthor"
                >
                    <font-awesome-icon :icon="['fas', 'star']" />
                    &nbsp;{{ $t("Preferiti") }}
                    <span
                        class="contatore-prodotti-preferiti position-absolute font-weight-bold d-inline-flex justify-content-center align-items-center"
                        v-if="numFavoriteItems > 0"
                    >
                        {{ numFavoriteItems }}
                    </span>
                </router-link>

                <router-link
                    :to="{ name: 'gallery-dashboard-customized' }"
                    class="nav-item nav-link mx-md-2 mx-lg-3 p-md-1 p-lg-2 position-relative"
                    active-class="active"
                    exact
                    v-if="!isAuthor && numCustomizedProducts > 0"
                >
                    <font-awesome-icon :icon="['fab', 'product-hunt']" />
                    &nbsp;{{ $t("Personalizzati") }}
                    <span class="contatore-prodotti-preferiti position-absolute font-weight-bold d-inline-flex justify-content-center align-items-center">
                        {{ numCustomizedProducts }}
                    </span>
                </router-link>

                <router-link
                    :to="{ name: 'gallery-cart' }"
                    class="nav-item nav-link mx-md-2 mx-lg-3 p-md-1 p-lg-2 position-relative d-none d-md-block"
                    active-class="active"
                    exact
                    :class="{ 'carrello-vuoto': numCartItems < 1 }"
                    v-if="!isAuthor"
                >
                    <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                    &nbsp;{{ $t("Carrello") }}
                    <span class="contatore-prodotti-carrello position-absolute font-weight-bold d-inline-flex justify-content-center align-items-center">
                        {{ numCartItems }}
                    </span>
                </router-link>

                <router-link
                    :to="{ name: 'gallery-contacts' }"
                    class="nav-item nav-link mx-md-2 mx-lg-3 p-md-1 p-lg-2 position-relative d-none d-md-block"
                    active-class="active"
                    exact
                    v-if="!isAuthor"
                >
                    <font-awesome-icon
                        :icon="['fas', 'comments']"
                        class="mr-2"
                    />
                    &nbsp;{{ $t("Contatti") }}
                </router-link>

                <span
                    class="nav-item dropdown text-left text-md-center ml-md-2 ml-lg-3"
                    v-if="!isAuthor && (!isPrivateEvent || !isVisitor)"
                >
                    <a
                        class="nav-link menu-utente non-loggato btn p-md-1 p-lg-2"
                        href="#"
                        @click.prevent="onLoginClicked()"
                        v-if="!isUserLoggedIn"
                    >
                        <font-awesome-icon :icon="['fas', 'user']" /> {{ $t("Accedi") }}
                    </a>

                    <!-- TODO: sistemare quando da mobile si apre il menu dropdown -->
                    <b-dropdown
                        v-if="isUserLoggedIn"
                        class="menu-utente d-inline d-md-inline-flex loggato"
                        right
                    >
                        <template slot="button-content">
                            <font-awesome-icon :icon="['fas', 'user']" /> <span class="d-inline nav-item nav-link text-uppercase p-0">{{ userFullName }}</span>
                        </template>
                        <b-dropdown-item
                            link-class="text-uppercase"
                            :to="resolveUrl({ name: 'gallery-account-profile' })"
                        >
                            {{ $t("I miei dati") }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            link-class="text-uppercase"
                            :to="resolveUrl({ name: 'gallery-account-orders' })"
                        >
                            {{ $t("I miei ordini") }}
                        </b-dropdown-item>
                        <b-dropdown-divider />
                        <b-dropdown-item
                            link-class="text-uppercase"
                            @click.prevent="onLogout()"
                        >
                            {{ $t("Logout") }}
                        </b-dropdown-item>
                    </b-dropdown>
                </span>
            </b-collapse>
        </b-navbar>

        <b-navbar
            toggleable="md"
            id="navbarSupportedContent"
            class="navbar-collapse p-0"
            v-if="showHeader('ALBUM_PHOTOS')"
        >
            <div
                id="nav-collapse"
                is-nav
                class="pulsante-indietro navbar-nav align-items-center text-uppercase"
            >
                <a
                    @click.prevent="onAlbumPhotosBackClicked"
                    class="nav-item nav-link"
                    href="#"
                >
                    <font-awesome-icon :icon="['fas', 'arrow-left']" />
                    &nbsp;<span class="d-none d-sm-inline">
                        {{
                        $t("Indietro")
                    }}</span>
                </a>
            </div>

            <span
                v-if="showHeader('ALBUM_PHOTOS')"
                class="navbar-text px-2 text-center text-truncate flex-grow-1 titolo-album"
            >{{ title }}
            </span>

            <div class="pulsante-acquista-foto text-right">
                <a
                    href="#"
                    class="btn btn-dark btn-rikorda1"
                    @click.prevent="onAlbumPhotosBuyClicked"
                    v-if="showHeader('ALBUM_PHOTOS') && !isAuthor && orderable"
                >
                    {{ $t("Acquista") }}
                </a>
            </div>
        </b-navbar>
        <gallery-popup-login
            v-if="showAuthPopup"
            :username="username"
            @login="onUserLogin"
            @close="onUserLoginClose"
        />
    </header>
</template>

<script>
import GalleryPopupLogin from "../../components/gallery/PopupLogin";
export default {
    name: "GalleryHeader",

    components: { GalleryPopupLogin },

    props: {
        header: { type: String, required: false, default: "" },
        title: { type: String, required: false, default: "" },
        orderable: { type: Boolean, required: false, default: true }
    },

    data() {
        return {
            showAuthPopup: false,
            galleryUrl: "",
            username: ""
        };
    },

    computed: {
        isGlobalSite() {
            var shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.isGlobalSite;
        },

        logoUrl() {
            var shopData = this.$store.getters.shopData;
            return shopData && shopData.logoUrl ? shopData.logoUrl : "";
        },

        numFavoriteItems() {
            var items = 0,
                userState = this.$store.getters.userState;
            if (userState) {
                items = userState["numFavorites"];
            }
            return items;
        },

        numCustomizedProducts() {
            var items = 0,
                userState = this.$store.getters.userState;
            if (userState) {
                items = userState["numCustomizedItems"];
            }
            return items;
        },

        numCartItems() {
            var items = 0,
                userState = this.$store.getters.userState;
            if (userState) {
                items = userState["numCartItems"];
            }
            return items;
        },

        isUserLoggedIn() {
            return this.$store.getters.userData != null;
        },

        userFullName() {
            var userData = this.$store.getters.userData;
            var fullname = userData.firstName ? userData.firstName : "";
            return userData.lastName
                ? fullname + " " + userData.lastName
                : fullname;
        },

        isAuthor() {
            return this.$store.getters.isAuthor;
        },

        isVisitor() {
            return this.$store.getters.isVisitor;
        },

        isPrivateEvent() {
            return this.$store.getters.isPrivateEvent;
        }
    },

    beforeCreate() {
        this.galleryUrl = this.$route.params.galleryUrl;
    },

    methods: {
        onLogout() {
            this.$store
                .dispatch("EVENT_AUTH_CLEANUP")
                .then((result) => {
                    console.debug("EVENT_AUTH_CLEANUP", result);
                })
                .catch((error) => {
                    console.error("EVENT_AUTH_CLEANUP", error);
                })
                .finally(() => {
                    this.$router.push({ name: "eventcode" });
                });
        },

        showHeader(header) {
            return this.$props.header === header;
        },

        onLoginClicked() {
            if (this.isPrivateEvent) {
                // evento privato + account esistente => setta username all'account esistente senza possibilità di modifica
                this.username = this.$store.getters.userState.email;
            }
            this.showAuthPopup = true;
        },

        // AlbumPhotos
        onAlbumPhotosBackClicked() {
            this.$emit("albumPhotosBack");
        },

        onAlbumPhotosBuyClicked() {
            this.$emit("albumPhotosBuy");
        },

        onPhotoselectionBackClicked() {
            this.$emit("photoselectionBack");
        },

        resolveUrl(data) {
            const resolver = this.$router.resolve(data);
            return resolver.resolved.matched.length ? resolver.href : "#";
        },

        onUserLogin(loginData) {
            this.$store.dispatch("UPDATE_USER_LOGIN", loginData);
            this.showAuthPopup = false;
            this.isLoginRequired = false;
        },

        onUserLoginClose() {
            this.showAuthPopup = false;
        }
    }
};
</script>

<style scoped>
.navbar-collapse {
    padding: 0 16px;
}

.non-loggato {
    border: none;
}
</style>
